<template lang="pug">
  .forgot-password
    template(v-if="processing")
      p.xs-f-small.max-at-tweak sending password reset email...

    template(v-else-if="forgotSms")
      p.xs-f-small.max-at-tweak It looks like you might not be getting our password reset emails. If you do not receive one shortly, would you like to receive your password reset link via text message (SMS) using mobile number on file?
      button.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(@click='sendPasswordResetSMS') Send

    template(v-else-if="!hasError && forgotSent === 'email'")
      p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Reset Password
      p.text-color-2.xs-f-small.max-at-tweak
        | We sent an email to&#32;
        span.user-email.semi-bold {{ userEmail }}
        | . Click the link in that email to finish logging in.

      p.please-allow.text-color-2.xs-f-xsmall.max-at-tweak Please allow up to 5 minutes for the verification link to be sent before requesting a new one.
      p.text-color-2.xs-f-xsmall.max-at-tweak
        | Can't find your link? Check your spam folder or&#32;
        button.btn-link.underline(type="button" @click="forgotPassword") click here to resend it
        | .
    template(v-else-if="!hasError && forgotSent === 'sms'")
      p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Reset Password
      p.text-color-2.xs-f-small.max-at-tweak
        | We sent an SMS to&#32;
        span.user-email.semi-bold {{ userEmail }}
        | . Click the link in that SMS to finish logging in.

      p.please-allow.text-color-2.xs-f-xsmall.max-at-tweak Please allow up to 5 minutes for the verification link to be sent before requesting a new one.
      p.text-color-2.xs-f-xsmall.max-at-tweak
        | Can't find your link? Check your spam folder or&#32;
        button.btn-link.underline(type="button" @click="forgotPassword") click here to resend it
        | .
    template(v-else)
      p.xs-f-small.max-at-tweak {{ forgotError }}

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { forgotPassword, sendPasswordResetSMS } from "@services/vueCustomerSvc";

  export default {
    name: "ForgotPassword",

    data() {
      return {
        forgotSms: false,
        forgotError: null,
        forgotSent: null,
        hasError: false,
      };
    },

    computed: {
      ...mapState('signIn', [
        'userEmail',
        'processing'
      ]),
    },

    methods: {
      ...mapActions([
        'notify'
      ]),

      ...mapMutations('signIn', [
        'setProcessing',
        'setView'
      ]),

      forgotPassword() {
        if (this.processing) {
          return;
        }

        this.setProcessing(true);

        forgotPassword({ email: this.userEmail }).then(() => {
          this.forgotSent = 'email';
          this.setProcessing(false);
        }).catch(err => {
          this.setProcessing(false);
          let error = err?.response;
          let doRedirect = false;
          let errorMessage = "Something went wrong and might not have been able to send password reset email, try again or please contact Color Crew for assistance.";

          if (error?.data) {
            if (error.data.message == "Invalid e-mail address") {
              doRedirect = true;
              errorMessage = error.data.message + ", redirecting to support page, one moment.";
            } else if (error.data.code == "UNSUBSCRIBED") {
              this.notify({
                class: "warn",
                message: "It looks like you might not be getting our password reset emails. If you do not receive one shortly please contact Color Crew for assistance.",
                time: 10000
              });
            } else if (error.data.code == "UNSUBSCRIBED_HAS_MOBILE") {
              this.forgotSms = true;
            } else {
              errorMessage = error.data.message;
            }
          }

          this.hasError = true;
          this.forgotError = errorMessage;

          if (doRedirect) {
            setTimeout(() => {
              window.location = "/support";
            }, 4000);
          }
        });
      },

      sendPasswordResetSMS() {
        sendPasswordResetSMS({ email: this.userEmail }).then(() => {
          this.forgotSent = 'sms';
        }).catch(() => {
          this.notify({
            class: "error",
            message:
              "Something went wrong and might not have been able to send SMS, try again or please contact Color Crew for assistance.",
            time: 10000
          });
        });
      },
    },

    mounted() {
      this.forgotPassword();
    }
  };
</script>

<style scoped lang="stylus">
  .forgot-password
    .please-allow
      padding-top 2em
      padding-bottom 0.5em
      
</style>
